import {JavascriptCallSetForumHashVO} from "./JavascriptCallSetForumHashVO";
import {AbstractJavascriptFunctionCallFactory} from "../../../controller/externalInterface/vo/AbstractJavascriptFunctionCallFactory";
import {AbstractJavascriptFunctionCallVO} from "../../../controller/externalInterface/vo/AbstractJavascriptFunctionCallVO";
import {BasicModel} from "../../BasicModel";

export class JavascriptCallOnSetForumHashFactory implements AbstractJavascriptFunctionCallFactory {
    /*override*/
    public createVO(): AbstractJavascriptFunctionCallVO {
        var vo: JavascriptCallSetForumHashVO = new JavascriptCallSetForumHashVO(BasicModel.forumData.rawServerForumHash);
        return vo;
    }
}
